// 🌐 SİTE DİL SEÇİCİ — tüm site (uygulama dahil) seçilen dile çevrilir (Google Translate motoru).
// Yöntem: googtrans çerezi + translate element script'i. Metin taşıma/i18n YOK — mevcut yapı bozulmaz.
// Script yalnız TR-dışı dil aktifken yüklenir (Türk kullanıcıya sıfır ek yük).
import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

// Almanca + İngilizce başta (Auren 2026-07-16), sonra yaygın diller
const LANGS: Array<{ code: string; label: string; flag: string }> = [
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

const readLang = (): string => {
  const m = document.cookie.match(/(?:^|;\s*)googtrans=\/tr\/([a-z-]+)/i);
  return m ? m[1].toLowerCase() : "tr";
};

const setTransCookie = (lang: string) => {
  const host = location.hostname;
  const bases = [host, host.startsWith("www.") ? host.slice(4) : `.${host}`];
  if (lang === "tr") {
    // Çerezi tüm domain varyantlarından sil
    for (const d of bases) {
      document.cookie = `googtrans=; path=/; domain=${d}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
    document.cookie = `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  } else {
    document.cookie = `googtrans=/tr/${lang}; path=/`;
    for (const d of bases) document.cookie = `googtrans=/tr/${lang}; path=/; domain=${d}`;
  }
};

const loadTranslateScript = () => {
  if (document.getElementById("google-translate-script")) return;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).googleTranslateElementInit = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const g = (window as any).google;
    if (g?.translate?.TranslateElement) {
      new g.translate.TranslateElement({ pageLanguage: "tr", autoDisplay: false }, "google_translate_element");
    }
  };
  const s = document.createElement("script");
  s.id = "google-translate-script";
  s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  document.body.appendChild(s);
};

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const [lang, setLang] = useState("tr");

  useEffect(() => {
    const current = readLang();
    setLang(current);
    if (current !== "tr") loadTranslateScript(); // aktif çeviri varsa motoru yükle
  }, []);

  const pick = (code: string) => {
    setTransCookie(code);
    setLang(code);
    location.reload(); // çeviri motoru sayfa yüklenirken devreye girer — en sağlam yol
  };

  const active = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <>
      {/* Google Translate bağlanma noktası (görünmez) */}
      <div id="google_translate_element" className="hidden" />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size={compact ? "icon" : "sm"} title="Dil / Language / Sprache" className="gap-1.5 notranslate">
            <Globe className="h-4 w-4" />
            {!compact && <span className="text-xs font-semibold uppercase">{active.code}</span>}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="notranslate">
          {LANGS.map((l) => (
            <DropdownMenuItem key={l.code} onClick={() => pick(l.code)} className={l.code === lang ? "bg-primary/10 font-semibold" : ""}>
              <span className="mr-2">{l.flag}</span>{l.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
